import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LazyLoadModule } from 'src/core-lib/lazy-load/lazy-load.module';
import { CarouselSimpleComponent } from 'src/layout/carousel/carousel-simple.component';
import { GridModule } from 'src/layout/grid/grid.module';
import { MediaModule } from 'src/layout/media/media.module';
import { BlockSliderComponent } from './block-slider.component';
import { ThumbnailPipe } from './thumbnail.pipe';




@NgModule({
  declarations: [BlockSliderComponent, ThumbnailPipe],
  imports: [
    CommonModule,
    GridModule,
    MediaModule,
    TranslateModule,
    CarouselSimpleComponent,
    LazyLoadModule,
  ]
})
export class BlockSliderModule {
    static components = { 'blockSliderElement': BlockSliderComponent };
}
